module.exports = __webpack_public_path__ + "img/15.426b8dc9.jpg";